// @ts-nocheck
/**
 * useTeam V2 - React Hook for Team Operations
 *
 * CREATED: Issue #473 - V2 Repository Pattern
 * Team primitive (Position #6/25) - CONFIGURE phase
 */

import { useMemo } from 'react';
import { useApolloClient } from '@apollo/client/react';
import { type ApolloClient } from '@apollo/client';
import { createTeamRepositoryV2 } from '../data/repositories/primitives';
import { useCurrentTenant } from './useCurrentTenant';

export function useTeam() {
  const client = useApolloClient() as ApolloClient;
  const { tenantId } = useCurrentTenant();
  const repository = useMemo(() => createTeamRepositoryV2(client), [client]);
  return { repository, tenantId };
}

